// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a9cb5305","239":"59c55318","732":"d86f11d9"}[chunkId] + ".chunk.js";
};